import { render, staticRenderFns } from "./ConfigAuthPage.vue?vue&type=template&id=18a40f7c&"
import script from "./ConfigAuthPage.vue?vue&type=script&lang=js&"
export * from "./ConfigAuthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports